import FJModal from '@src/components/FJModals/FJModal';
import { useAppDispatch, useAppSelector } from '@src/redux/hooks.ts';
import FJPublishHistory from '@src/components/FJModals/FJPublishHistoryModal/FJPublishHistory.tsx';
import FJPublishHistorySlice from '@src/redux/slice/modal/FJPublishHistorySlice.ts';

const FJPublishHistoryModal = () => {
    const dispatch = useAppDispatch();
    const { isShow, history } = useAppSelector(state => {
        return {
            isShow: state.modal.publishHistory.isShow,
            history: state.modal.publishHistory.history,
        };
    });

    const onClose = () => {
        dispatch(FJPublishHistorySlice.actions.setIsShow(false));
    };

    return (
        <FJModal width={525} visible={isShow}>
            <FJPublishHistory historyList={history} onClose={onClose} />
        </FJModal>
    );
};

export default FJPublishHistoryModal;
